import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8abf06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "タイムライン", -1))
const _hoisted_2 = { class: "text-right" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新規作成")
const _hoisted_4 = { class: "pl40" }
const _hoisted_5 = ["infinite-scroll-disabled"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "comment" }
const _hoisted_8 = { class: "ml10" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Loading...")
const _hoisted_13 = [
  _hoisted_12
]

import { TimeLinesLogic } from '@/logic/time_lines/TimeLinesLogic'
import { ChatDotRound } from '@element-plus/icons';
import { NoticeState } from "@/state/NoticeState";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { loadTimeLines, time_lines, loadTimeLineDisable, timeLineLoading, filterUnread } = TimeLinesLogic();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'TimeLineCreate', params: { project_id: _ctx.$route.params.project_id } },
          class: "button-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_checkbox, {
          class: "pr5",
          modelValue: _unref(filterUnread),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterUnread) ? (filterUnread).value = $event : null)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(loadTimeLines)(true))),
          label: "未読のみ"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_badge, {
          "is-dot": "",
          class: "item",
          hidden: _unref(NoticeState).get( _ctx.$route.params.project_id).includes('time_line_index') == false
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ChatDotRound))
          ]),
          _: 1
        }, 8, ["hidden"])
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("ul", {
          gutter: 12,
          class: "infinite-list",
          "infinite-scroll-disabled": _unref(loadTimeLineDisable)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(time_lines), (time_line) => {
            return (_openBlock(), _createElementBlock("li", {
              key: time_line.id
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'TimeLine', params: { project_id: _ctx.$route.params.project_id, time_line_id: time_line.id } },
                class: "button-link"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    shadow: "never",
                    class: _normalizeClass({new: time_line.notice || time_line.notice_comment })
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "body mb10",
                        innerHTML: time_line.body
                      }, null, 8, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, [
                        _createTextVNode(_toDisplayString(time_line.comment_count) + "個のコメント ", 1),
                        _createVNode(_component_el_badge, {
                          "is-dot": "",
                          class: "item",
                          hidden: time_line.notice_comment == false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ChatDotRound))
                          ]),
                          _: 2
                        }, 1032, ["hidden"]),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(time_line.iine_count) + "人がいいねしてます", 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(time_line.post_at), 1),
                        _createTextVNode(" " + _toDisplayString(time_line.user_name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ], 8, _hoisted_5), [
          [_directive_infinite_scroll, _unref(loadTimeLines)]
        ]),
        (_unref(timeLineLoading))
          ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_11, _hoisted_13, 512)), [
              [_directive_loading, _unref(timeLineLoading)]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})